import { OVERLAY_KEYBOARD } from "@/utils/constants";
export default {
  namespaced: true,
  state() {
    return {
      enter: OVERLAY_KEYBOARD.MODAL,
      // enter: OVERLAY_KEYBOARD.DROPDOWN
      isSelectOrg: false,
    };
  },

  getters: {},
  mutations: {
    SET_ENTER(state, value) {
      state.enter = value;
    },
  },
};
